module.exports = __webpack_public_path__ + "1f68063f84a63ccf284c26281693697a.svg";